const BASE_PATH = "app/activity-center/";

export const SET_DATA = `${BASE_PATH}set-data`;
